import { useMemo } from 'react';
import { useRouter } from '@edreamsodigeo/frontend-core';

export const BOOKING_ID_REGEX = new RegExp(/.*\/(\d{10,12})(?:\/.*)?$/);
const SHOPPING_ID_REGEX = new RegExp(
  /.*\/([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})\/.*$/
);

const useShoppingIdFromUrl = (): number | string => {
  const { query, pathname } = useRouter();
  const bookingId = useMemo(() => {
    const [, bookingId] = pathname.match(BOOKING_ID_REGEX) || [];
    return bookingId;
  }, [pathname]);
  const shoppingId = useMemo(() => {
    const [, shoppingId] = pathname.match(SHOPPING_ID_REGEX) || [];
    return shoppingId;
  }, [pathname]);
  const shoppingIdIdParam =
    (query?.bookingId as string) || (query?.shoppingId as string);
  return shoppingIdIdParam || bookingId || shoppingId || 0;
};

// Please use the useShoppingId hook instead of this function so that you can use the shoppingId from the context if passed as a prop
export default useShoppingIdFromUrl;
